import { render, staticRenderFns } from "./WashingtonArticle.vue?vue&type=template&id=5c5748de&"
import script from "./WashingtonArticle.vue?vue&type=script&lang=js&"
export * from "./WashingtonArticle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports